import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subscriptionStatusPipe'
})
export class SubscriptionStatusPipe implements PipeTransform {

  private listObj = {
    0: 'Pending Payment',
    1: 'Active',
    2: 'Expired',
    3: 'Cancelled Ongoing',
    4: 'Cancelled',
    5: 'Failed Payment',
    6: 'Bypassed',

  };

  transform(value: number): string {
    console.log("transforming: ", value)
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
